export const NAV_PLACEMENTS = Object.freeze({
  SITE: 'site',
  PORTFOLIO: 'portfolio',
  ADMIN: 'admin',
  HELP: 'help',
  MESSAGING: 'messaging',
  FOOTER: 'footer',
  HEADER: 'header',
});
